import * as actionTypes from "../action-types";

const initialState = {
    consultationTimerCountdown: 0,
    currentConsultationSessionData: {}
};

const consultationReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_CONSULTATION_TIMER_COUNTDOWN:
            return { ...state, consultationTimerCountdown: payload }

        case actionTypes.SET_CURRENT_CONSULTATION_SESSION_DATA:
            return { ...state, currentConsultationSessionData: payload }

        default:
            return state;
    }
};

export default consultationReducer;